import { render, staticRenderFns } from "./EditCostumerRelation.vue?vue&type=template&id=880d7378"
import script from "./EditCostumerRelation.vue?vue&type=script&lang=js"
export * from "./EditCostumerRelation.vue?vue&type=script&lang=js"
import style0 from "./EditCostumerRelation.vue?vue&type=style&index=0&id=880d7378&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports